const isUnifiedSignupForm = ref(false);
const ussIsStartScreen = ref(true);
const ussProps = ref();

export const useFormState = () => {
  return {
    isUnifiedSignupForm,
    ussIsStartScreen,
    ussProps,
  };
};
